













































































































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { sensitivePicQuery, sensitiveEditPic, sensitiveDelPic } from '@/service/data'
// import { illegalTypes, getIllegalTypes } from '@/service/settings'
import { getConstants } from '../../../service/common'
import { BUSSINESS, BUSSINESS_SUBJECTS, BUSSINESS_SIDES } from '../../../service/constant'
import { ConstantMixins } from '../modules/ConstantMixins'

@Component
export default class ImageBank extends Mixins(ConstantMixins) {
  // 国际化配置
  public localeZHCN = zhCN
  // search-data
  public searchParams = {
    pic_name: '',
    pic_sample: 0,
    sensitive_type: [0],
    page_index: 1,
    business_side: '', // 业务方id
    pic_from: '', // 图片来源
    pic_subject: '' // 学科
  }
  public sampleTypes = [[0, '不限'], [1, '正样本'], [2, '负样本']]
  public sampleTypes1 = [[1, '正样本'], [2, '负样本']] // 修改弹框里面的样本类型库

  // public imageBankTypes = getIllegalTypes([0, '不限'])

  // pagination-data
  public Total = 0
  public Current = 1
  public pageSizeValue = 20
  // list-data
  public imageBanks = new Array<object>()

  public isModalVisible: boolean = false
  public confirmLoading: boolean = false

  public deleteVisible: boolean = false
  public confirmDeleteLoading: boolean = false

  public pictureVisible: boolean = false
  public imgSrc: string = ''

  public pic_id: string = ''
  public pic_name: string = ''
  public pic_sample1: string = '' // 修改弹框里面的样本类型
  public sensitive_type = []
  public auditor: string = ''
  public pic_from: string = ''
  public resource_url: string = ''

  // public illegalTypes = [
  //   { label: '涉黄', value: 1 },
  //   { label: '涉毒', value: 2 },
  //   { label: '涉赌', value: 3 },
  //   { label: '涉暴', value: 4 },
  //   { label: '涉恐', value: 5 },
  //   { label: '涉政', value: 6 },
  //   { label: '其他', value: 7 }
  // ]
  public illegeArr = []
  public pic = {
    id: ''
  }

  // 业务方id集合
  private get businessSides() {
    var sides = this.$store.state[BUSSINESS_SIDES]
    return sides
  }

  // 图片来源集合
  private get business() {
    var business = this.$store.state[BUSSINESS]
    return business
  }

  // 学科集合
  private get subjects() {
    if (!this.searchParams.pic_from) return []
    const dict = this.$store.state[BUSSINESS_SUBJECTS]
    return dict[this.searchParams.pic_from] || []
  }

  @Watch('searchParams.pic_from')
  public onBussinessChange(val) {
    if (val === '') {
      this.searchParams.pic_subject = ''
    }
    if (!this.subjects || this.subjects.length == 0) return
    if (!this.subjects.map((item) => item.value).includes(this.searchParams.pic_subject)) {
      setTimeout(() => {
        this.searchParams.pic_subject = this.subjects[0].value
      })
    }
  }

  /*
   * created
   */
  public created() {
    this.searchSensitivePic(1)
    window.onresize = this.setImageHeight
  }
  /*
   * watch
   */
  @Watch('imageBanks')
  public onImageBanksChange(val) {
    this.$nextTick(function() {
      this.setImageHeight()
    })
  }
  /*
   * methods
   */
  // 查询敏感图
  public async searchSensitivePic(page) {
    this.searchParams.page_index = page
    let response = await sensitivePicQuery(this.searchParams)
    if (response.success) {
      this.imageBanks = response.data
      this.pageSizeValue = response.page_size
      this.Total = response.total
      this.Current = response.page_index
    }
  }
  // 页码变化
  public pageChange(page) {
    this.searchSensitivePic(page)
  }
  // 图片高度自适应
  public setImageHeight() {
    let imageItems = document.querySelectorAll('.image-bank__image') as NodeListOf<HTMLImageElement>
    let descriptionItems = document.querySelectorAll('.image-bank__description') as NodeListOf<
      HTMLDivElement
    >
    for (let i = 0; i < imageItems.length; i++) {
      let imageItem = imageItems.item(i)
      let descriptionItem = descriptionItems.item(i)
      let width = imageItem.width
      let height = width * 1.618
      imageItem.height = height * 0.7
      let descriptionHeight = height * 0.3
      descriptionItem.style.height = `${descriptionHeight}px`
    }
  }

  // 修改
  public updateItem(item) {
    this.isModalVisible = true
    if (item) {
      const { id, name, pic_sample, sensitive_type, auditor, resource_url } = item

      this.pic_id = id
      this.pic_name = name
      this.pic_sample1 = pic_sample
      this.sensitive_type = sensitive_type
      this.auditor = auditor
      this.resource_url = resource_url
    }
  }

  public handleModalOk() {
    var obj = {
      pic_id: this.pic_id,
      pic_name: this.pic_name,
      pic_sample: this.pic_sample1,
      sensitive_type: this.sensitive_type
    }

    this.confirmLoading = false
    this.isModalVisible = false

    this._editSensitivePic(obj)
  }

  // 修改图片库
  public async _editSensitivePic(obj) {
    let response = await sensitiveEditPic(obj)
    if (response.success) {
      this.searchSensitivePic(1)
    }
  }

  public handleModalCancel(e) {
    this.isModalVisible = false
  }

  // 删除
  public deleteItem(item) {
    this.deleteVisible = true
    this.pic = item
  }

  public handleDeleteOk() {
    this.confirmLoading = false
    this.deleteVisible = false
    this._deleteSensitivePic()
  }
  // 删除图片库
  public async _deleteSensitivePic() {
    let params = { pic_id: this.pic.id }
    let response = await sensitiveDelPic(params)
    if (response.success) {
      this.searchSensitivePic(1)
    }
  }

  public handleDeleteCancel(e) {
    this.deleteVisible = false
  }

  public imgOpen(src) {
    this.pictureVisible = true
    this.imgSrc = src
  }

  public handleModelClose(e) {
    this.pictureVisible = false
  }
}
